import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
 
const AnyReactComponent = ({ text }) => <i style={{color:"#fff"}} className={text}></i>;
 
class Map extends Component {
  static defaultProps = {
    center: {
      lat: 27.7360,
      lng: 85.3601
    },
    zoom: 11
  };
 
  render() {
    return (
      // Important! Always set the container height explicitly
      <div style={{ height: '60vh', width: '100%' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyB8UW9DQg9OII9Hz1lAZUgu-izvQ29U9J8"}}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
        >
          <AnyReactComponent
            lat={27.7360}
            lng={85.3601}
            text="fas fa-map-marker-alt"
          />
        </GoogleMapReact>
      </div>
    );
  }
}
 
export default Map;